module.exports = __webpack_public_path__ + "static/media/logo-b.2a99972d.png";